import React from "react";
import { IBaseSrcAlt } from "../../Interfaces/base";

interface ServiceBoxProps {
  icon: IBaseSrcAlt;
  title: string; 
  description: string | string[];
}

const ServiceBox = ({ icon, title, description }: ServiceBoxProps) => {

  const normalizedContent = Array.isArray(description) ? description.join(", ") : description;

  return(<div className="service-box me-5 mt-4">
    <div className="icon-container align-items-center justify-content-center d-flex mb-3">
      <img src={icon.src} className="icon" alt='service-icon' />
    </div>
    <div className="title mb-3">{title}</div>
    <div className="description" dangerouslySetInnerHTML={{ __html: normalizedContent }} />
  </div>)
}

export default ServiceBox;